export default {
  header: {
    house: 'Haus',
    activities: 'Aktivitäten',
    beaches: 'Strände',
    history: 'Geschichte',
    contact: 'Kontakt',
    phone: '+30 6983446269'
  },
  hero: {
    title: 'Erschaffen Sie Ihre Entspannungsflucht auf Kreta',
    bookNow: 'Jetzt buchen',
    phone: '+30 6983446269',
    airbnb: 'Airbnb',
    booking: 'Booking',
    yourRentals: 'YourRentals'
  },
  house: {
    title: 'Azure Loft',
    description: 'Entdecken Sie das Azure Loft, ein charmantes Boho-Apartment im Herzen Kretas, das für absolute Entspannung und Komfort gestaltet wurde. Mit atemberaubendem Meerblick, warmer Boho-Ästhetik und allen modernen Annehmlichkeiten ist es die ideale Wahl für Paare, Familien oder Freunde, die ein einzigartiges Unterkunftserlebnis suchen.',
    features: [
      'Räumlichkeiten',
      '1 Schlafzimmer im traditionellen Holzloft mit komfortablem Doppelbett',
      'Essbereich mit Schlafsofa, geeignet für einen weiteren Gast',
      'Gemütliches Wohnzimmer mit Fernseher und heller Dekoration',
      'Balkon mit Tisch und Stühlen, ideal um den einzigartigen Meerblick zu genießen',
      'Küche & Ausstattung',
      'Voll ausgestattete Küche mit Kühlschrank, Ofen, Kochfeld, Kaffeemaschine und allen notwendigen Utensilien',
      'Badezimmer mit Dusche, modernen Sanitäranlagen und 24/7 Warmwasser',
      'Annehmlichkeiten & Extras',
      'Klimaanlage',
      'Waschmaschine und Bügeleisen',
      'Frische weiße Bettwäsche (Bettlaken, Handtücher, Kissen)',
      'Flachbildfernseher',
      'Einfache Parkmöglichkeiten in der Nähe der Unterkunft'
    ],
    bookNow: 'Jetzt buchen',
    rooms: {
      bedroom: 'Schlafzimmer',
      livingRoom: 'Wohnzimmer',
      bedroom2: 'Schlafzimmer 2',
      kitchen: 'Küche',
      veranda: 'Veranda'
    },
    viewPhotos: 'Fotos ansehen',
    closeGallery: 'Schließen'
  },
  reasons: {
    title: 'Die 5 besten Gründe zu bleiben',
    reason1: {
      title: '1. Atemberaubende Aussichten',
      description: 'Vom Balkon des Azure Loft erleben Sie eine Szene wie aus einem Gemälde: das endlose kretische Meer, der Hafen von Heraklion im Hintergrund und die Sonnenuntergangsfarben, die jeden Abend den Himmel bemalen. Perfekt für morgendlichen Kaffee und abendlichen Wein mit einem einzigartigen Gefühl der Ruhe.'
    },
    reason2: {
      title: '2. Die Stadt... nur einen Atemzug entfernt',
      description: 'Obwohl Sie sich in einem ruhigen Dorf befinden, ist das Zentrum von Heraklion nur 15-20 Minuten entfernt. Dort finden Sie alles, was Sie brauchen: von Museen und Sehenswürdigkeiten bis hin zu einem lebendigen Markt, Restaurants, Bars und kulturellen Veranstaltungen. Der Zugang ist einfach und ideal für Tagesausflüge.'
    },
    reason3: {
      title: '3. Authentisches Kreta',
      description: 'Rodia ist eines der schönsten traditionellen Dörfer in Heraklion. Auf einem Hügel mit Meerblick erbaut und gefüllt mit steingepflasterten Gassen, kleinen Höfen und alten Häusern bietet es ein Gefühl der Authentizität, das selten ist. Es ist ein Ort, an dem die Zeit langsamer vergeht – und das ist sein größtes Privileg.'
    },
    reason4: {
      title: '4. Kristallklare Strände',
      description: 'Weniger als 20 Autominuten vom Azure Loft entfernt warten Strände für jeden Geschmack. Ammoudara bietet Organisation und Lebendigkeit, Ligaria ist ideal für Familien mit sauberem, ruhigem Wasser, während Agia Pelagia schöne Landschaft mit gutem Essen am Meer kombiniert. Für ruhigere Momente bevorzugen Sie Made oder das malerische Psaromoura mit kristallblauem Wasser und authentischer kretischer Atmosphäre.'
    },
    reason5: {
      title: '5. Für Momente, die bleiben',
      description: 'Azure Loft ist ideal für diejenigen, die dem Gewöhnlichen entfliehen und etwas Authentischeres, Menschlicheres und Friedlicheres erleben möchten. Ob Sie mit Ihrem Partner, Ihrer Familie oder Freunden reisen, hier werden Sie echte Entspannung spüren und Erinnerungen schaffen, an die Sie sich mit einem Lächeln erinnern werden.'
    }
  },
  reviews: [
    {
      author: 'Gerasimos',
      date: 'vor 5 Monaten',
      rating: 5,
      text: 'Wir hatten eine ausgezeichnete Erfahrung während unseres Aufenthalts im Ferienhaus! Die Unterkunft war makellos, vollständig ausgestattet und sehr komfortabel. Die Lage war ideal, nah an allem, was wir brauchten, aber gleichzeitig ruhig genug, um unsere Ruhe zu genießen. Der Besitzer war extrem freundlich und hilfsbereit, immer verfügbar, um uns bei Fragen oder Bedürfnissen zu helfen, die auftauchten. Er gab uns auch nützliche Ratschläge über die Gegend, wie Orte zum Essen und Aktivitäten. Das Haus hatte moderne Dekoration, bequeme Betten und alles, was wir brauchten, um uns zu Hause zu fühlen. Das WLAN war schnell und zuverlässig, was wir besonders schätzten. Insgesamt eine fantastische Erfahrung, die ich definitiv jedem empfehlen würde, der nach qualitativ hochwertiger Unterkunft sucht. Wir können es kaum erwarten, zurückzukehren!'
    },
    {
      author: 'Ioannis Papadakis',
      date: 'vor 5 Monaten',
      rating: 5,
      text: 'Wirklich ein wunderschönes warmes Haus mit erstaunlichen Aussichten. Wir blieben für eine kurze Zeit in Heraklion, da unser Ziel südlich von Rethymno war. Das erste, was unsere Aufmerksamkeit erregte, war die Aussicht, als wir die Buchung machten, und sie ist wirklich unglaublich. Außerdem ist das Haus sehr sauber und roch gut, was sehr angenehm ist, wenn Sie zum ersten Mal in die Villa eintreten.'
    },
    {
      author: 'Panagiotis Chandroulidis',
      date: 'vor 1 Monat',
      rating: 5,
      text: 'Es ist wunderbar mit schönen Aussichten. Der Besitzer ist gastfreundlich und sehr nett. Ich empfehle Ihnen, es zu wählen, ich bin sicher, Sie werden Ihren Aufenthalt genießen.'
    },
    {
      author: 'Vasilis',
      date: '2. März 2025',
      rating: 5,
      text: 'Das Haus war sehr schön und ideal für romantische Ausflüge. Vollständig ausgestattet und wir konnten kochen😊 Die Aussicht in der Nacht war fantastisch vom Haus aus zusammen mit einem Glas Wein war es etwas Besonderes. Die Gastgeberin schickte uns detaillierte Anweisungen für das Haus. Ziemlich freundlich. Sehr guter Eindruck insgesamt.',
      source: 'booking'
    },
    {
      author: 'Sevi Kallergi',
      date: 'vor 23 Wochen',
      rating: 5,
      text: 'Magische Aussichten und komfortabler Raum. Es war sauber und alles war perfekt! Ruhig und entspannend. Ich werde definitiv wieder gehen!'
    },
    {
      author: 'alex tevre',
      date: 'vor 24 Wochen',
      rating: 5,
      text: 'Als häufiger Besucher Kretas kann ich ehrlich sagen, dass dies eine der besten Wohnungen war, in denen ich je gewohnt habe! Das Erstaunliche...'
    },
    {
      author: 'Eirini Vrentzou',
      date: 'vor 24 Wochen',
      rating: 5,
      text: 'Wirklich wunderbar.... Ich habe keine Worte, um die Schönheit zu beschreiben..alles war perfekt und gut gepflegt...ich empfehle es ohne Vorbehalt...'
    },
    {
      author: 'Antonis Aerakis',
      date: 'vor 24 Wochen',
      rating: 5,
      text: 'Alles war perfekt! Wunderbarer und sauberer Raum mit unglaublichen Aussichten!'
    },
    {
      author: 'Konstantina Orfanou',
      date: 'vor 24 Wochen',
      rating: 5,
      text: 'Sehr schöner Raum und die Gastgeber sind freundlich, hilfsbereit und bereit zu helfen....'
    },
    {
      author: 'Penny Stathogiannopoulou',
      date: 'vor 24 Wochen',
      rating: 5,
      text: 'Wunderbarer Raum mit sehr schöner Ästhetik. Makellos und bis ins letzte Detail gut gepflegt! Mein Lieblingsort...'
    },
    {
      author: 'MARIA IOANNA RESTIVAKI',
      date: 'vor 24 Wochen',
      rating: 5,
      text: 'Wenn Sie nach einem friedlichen und malerischen Rückzugsort suchen, ist dieses Ferienhaus in Rodia eine ausgezeichnete Wahl!...'
    },
    {
      author: 'Maria Stavroulaki',
      date: 'vor 24 Wochen',
      rating: 5,
      text: 'Sehr schöner Raum und kombiniert mit der unglaublichen Aussicht auf Heraklion machte unseren Aufenthalt unvergesslich!!'
    },
    {
      author: 'vasilis maris',
      date: 'vor 24 Wochen',
      rating: 5,
      text: 'Ich gratuliere Ihnen zu der Schönheit und Renovierung Ihres Hauses. Unser Aufenthalt war wunderbar und das...'
    },
    {
      author: 'Manos Papadakis',
      date: 'vor 24 Wochen',
      rating: 5,
      text: 'Sehr schöne Aussichten, der Mieter sehr hilfsbereit und jedes Problem, das ich hatte, wurde sofort gelöst. Ich empfehle es ohne Vorbehalt für Ihre Ferien, ob Sommer oder Winter 😁'
    },
    {
      author: 'Panagiotis',
      date: '25. Juni 2025',
      rating: 5,
      text: 'Der Besitzer und Manager sind wunderbare Menschen, gastfreundlich und nett. Wir hatten einen perfekten Aufenthalt und eine wunderbare Zusammenarbeit. Das Haus war sauber und bei unserer Ankunft wurden wir mit einer schönen Überraschung begrüßt. Aber das Highlight ist der Balkon, die Aussicht ist wunderschön, Sie können ganz Heraklion und das endlose Blau des Meeres sehen.',
      source: 'booking'
    },
    {
      author: 'Lise',
      date: 'Mai 2025',
      rating: 3,
      text: 'Gute Lage, um die Gegend von Heraklion zu besuchen und in der Nähe des Flughafens. Kleine Unterkunft für 4 Personen (einschließlich Kinder, Wendeltreppe). Einige Verbesserungen sind erforderlich...',
      source: 'airbnb'
    },
    {
      author: 'Emmanouil',
      date: 'April 2025',
      rating: 5,
      text: 'Ruhiger Ort mit schönen Aussichten. Die Kommunikation war ausgezeichnet.',
      source: 'airbnb'
    },
    {
      author: 'Emmanouil',
      date: 'März 2025',
      rating: 5,
      text: 'Das Haus war sehr sauber und die Aussicht vom Balkon war erstaunlich und Sie hatten alle Annehmlichkeiten und der Gastgeber war sehr freundlich und half mir bei jedem Problem, das ich hatte',
      source: 'airbnb'
    }
  ],

  // Reviews Section
  reviewsSection: {
    subtitle: 'Was unsere Besucher sagen!',
    title: 'Bewertungen'
  },

  location: {
    title: 'Unser Standort',
    subtitle: 'Ein malerisches Paradies',
    description: 'Azure Loft befindet sich im bezaubernden Rodia von Heraklion, einer traditionellen kretischen Siedlung, die amphitheatralisch auf einem Hügel erbaut wurde, mit Panoramablick auf das kretische Meer und die Stadt Heraklion. Rodia verbindet authentische Gastfreundschaft mit einzigartiger natürlicher Schönheit und dient als idealer Ausgangspunkt für die Erkundung sowohl des Hinterlandes als auch der Nordküste der Insel.\n\nIn der Nähe können Sie kristallklares Wasser entdecken, wie Palaikastro, Ammoudara und den Hafen von Ligaria, ideal zum Schwimmen, Sonnenbaden und für Wassersportaktivitäten.\n\nGeschichts- und Kulturbegeisterte können leicht das Archäologische Museum von Heraklion (18 km), die Venezianischen Mauern (17 km) sowie den weltberühmten Palast von Knossos (21 km) besuchen. Für einen Familienausflug ist das Cretaquarium – Thalassokosmos nur 33 km entfernt und bietet eine unvergessliche Erfahrung für Jung und Alt.\n\nDie Lage des Azure Loft gewährleistet einen einfachen Zugang zum Internationalen Flughafen Heraklion (20 km), während die Unterkunft auch über kostenlose Privatparkplätze verfügt und Komfort für Ihre Transporte bietet.\n\nEntdecken Sie den Charme des authentischen Kreta mit dem Meer als Hintergrund und der Ruhe der halbbergigen Landschaft von Rodia.'
  },
  calendar: {
    title: 'Azure Loft Verfügbarkeit',
    close: 'Schließen',
    bookAirbnb: 'Auf Airbnb buchen',
    bookBooking: 'Auf Booking buchen',
    bookYourRentals: 'Auf YourRentals buchen',
    requestQuote: 'Angebot anfordern'
  },
  footer: {
    generalInfo: 'Allgemeine Informationen',
    location: 'Standort',
    getDirections: 'Wegbeschreibung',
    contactWays: 'Kontaktmöglichkeiten',
    faq: 'Häufig gestellte Fragen',
    usefulLinks: 'Nützliche Links',
    carRental: 'Autovermietung',
    busRoutes: 'Buslinien',
    cityGuide: 'Stadtführer',
    socialMedia: 'Soziale Medien',
    newsletter: 'Newsletter',
    emailPlaceholder: 'Ihre E-Mail',
    signUp: 'Anmelden!',
    copyright: 'Copyright © AZURE LOFT GREECE 2025',
    manual: 'Haus-Handbuch'
  },
  contact: {
    title: 'Kontaktieren Sie uns',
    phone: 'TELEFON',
    email: 'E-MAIL',
    namePlaceholder: 'Geben Sie Ihren Namen ein',
    emailPlaceholder: 'Geben Sie eine gültige E-Mail-Adresse ein',
    messagePlaceholder: 'Ihre Nachricht',
    submit: 'ABSENDEN',
    sending: 'Wird gesendet...',
    success: 'Ihre Nachricht wurde erfolgreich gesendet!',
    error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
  },
  readMore: 'Mehr lesen',
  readLess: 'Weniger lesen'
}; 